// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="text-zinc-500 text-sm">Loading...</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (adminOnly && user.role !== "ADMIN") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-6">
        <div className="bg-white border border-zinc-200 p-10 text-center max-w-md">
          <div className="data-label text-[#991B1B] mb-3">Access Denied</div>
          <h1 className="font-heading text-2xl font-bold mb-2">Admin only</h1>
          <p className="text-sm text-zinc-600">This area is restricted to administrators.</p>
        </div>
      </div>
    );
  }
  return children;
}
